// Groups the raw report into the CSR-facing categories shown in the summary and details panels.
export const buildCategories = (report, ports = {}, trans = (key) => key) => {
  const { reachability } = report;

  const categories = [
    {
      key: 'core',
      title: 'Core Connectivity',
      tests: [
        { label: 'Portal Access', port: ports.portal || '443', status: reachability.portal },
        { label: 'API Access', port: ports.api || '443', status: reachability.api },
      ],
    },
    {
      key: 'realtime',
      title: 'Real-time Services',
      tests: [
        { label: 'Notifications', port: ports.wss || '3563', status: reachability.wss },
        { label: 'Authentication', port: ports.oauth || '8443', status: reachability.oauth },
      ],
    },
  ];

  if (report.videoCall) {
    categories.push({
      key: 'videoCalling',
      title: trans('DIAGNOSTICS_VIDEO_MEDIA'),
      tests: [
        { transport: 'udp', label: trans('DIAGNOSTICS_UDP_CONNECTIVITY'), port: ports.videoUdp || 'UDP' },
        { transport: 'tcp', label: trans('DIAGNOSTICS_TCP_CONNECTIVITY'), port: ports.videoTcp || 'TCP' },
      ].map(({ transport, ...test }) => {
        const result = report.videoCall[transport];
        return {
          ...test,
          status: result.status,
          failMessage: report.videoCall.reason
            ? `${trans('DIAGNOSTICS_SETUP_FAILED')} (${report.videoCall.step}: ${result.feedback})`
            : `${trans('DIAGNOSTICS_TRANSPORT_FAILED')} (${result.feedback})`,
        };
      }),
    });
  }

  return categories.map((category) => ({
    ...category,
    status: category.tests.every((test) => test.status === 'pass') ? 'pass' : 'fail',
  }));
};
